import store from "../../../store";
import loko_export from './loko_export.vue';

window.loko_export =  new Vue({
    store,
    el: 'div#loko_export',

    name : "loko_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        loko_export,
    }
});
